import React from 'react';
import PropTypes from 'prop-types';
import BaseIconButtonWithTooltip from '../BaseIconButtonWithTooltip';

function ToolbarIconButtonWithTooltip(props) {
  return React.createElement(BaseIconButtonWithTooltip, props);
}

ToolbarIconButtonWithTooltip.propTypes = {
  color: PropTypes.oneOf(['default', 'primary', 'secondary', 'inherit']),

  /**
   * Pokud je `true` bude button disablovany.
   */
  disabled: PropTypes.bool,

  /**
   * Icona buttonu => node.. Zapis napr: <Icon />. Pokud je definovan children je ikona ignorovana.
   */
  icon: PropTypes.node,
  iconColor: PropTypes.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),

  /**
   * Popis buttonu, ktery se objevi v tooltipu.
   */
  label: PropTypes.string,

  /** () => void */
  onClick: PropTypes.func
};
ToolbarIconButtonWithTooltip.defaultProps = {
  color: undefined,
  disabled: undefined,
  icon: undefined,
  iconColor: 'action',
  label: undefined,
  onClick: undefined
};
export default ToolbarIconButtonWithTooltip;